import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import VueWysiwyg from "@mycure/vue-wysiwyg";
import FloatingVue from "floating-vue";
import constants from "./assets/js/constants";
import isXSSAttempt from "./utils/xssUtil";

import VueSignature from "vue-signature-pad";
import VueCropper from "vue-cropper";
import PrimeVue from "primevue/config";

//Check if it is opened from iframe
if (window.self !== window.top) {
  // The app is in an iframe
  document.body.innerHTML =
    "<h1>This application cannot be displayed in an iframe.</h1>";
}

Vue.use(VueCropper);
Vue.use(VueSignature);

Vue.use(PrimeVue);

const urlSearchParams = new URLSearchParams(window.location.search);
const obfuscatedDocId = urlSearchParams.get("docId");
const obfuscatedTrasferId = urlSearchParams.get("transferId");
const obfuscatedelegationId = urlSearchParams.get("delegationId");
const encDocId = urlSearchParams.get('encDocId');
const encTransferId = urlSearchParams.get('encTransferId');
const encToUserId = urlSearchParams.get('encToUserId');
const encToStructureId = urlSearchParams.get('encToStructureId');
const landingNodeId = urlSearchParams.get('nodeId');

try {
  if (obfuscatedDocId !== null && obfuscatedDocId !== undefined) {
    const docId = atob(obfuscatedDocId);
    sessionStorage.setItem("docId", docId);
  }
  if (obfuscatedTrasferId != null && obfuscatedTrasferId != undefined) {
    const transferId = atob(obfuscatedTrasferId);
    sessionStorage.setItem("transferId", transferId);
  }
  if (obfuscatedelegationId != null && obfuscatedelegationId != undefined) {
    const delegationId = atob(obfuscatedelegationId);
    sessionStorage.setItem("delegationId", delegationId);
  }
  if(encDocId != null && encDocId != undefined) {
	  sessionStorage.setItem('encDocId',encDocId);
  }
  if(encTransferId != null && encTransferId != undefined) {
	  sessionStorage.setItem('encTransferId',encTransferId);
  }
  if(encToUserId != null && encToUserId != undefined) {
	  sessionStorage.setItem('encToUserId',encToUserId);
  }
  if(encToStructureId != null && encToStructureId != undefined) {
	  sessionStorage.setItem('encToStructureId',encToStructureId);
  }
  if(landingNodeId != null && landingNodeId != undefined) {
	  sessionStorage.setItem('encNodeId',landingNodeId);
  }
} catch (error) {
  console.error("Error decoding obfuscatedDocId:", error);
}
axios.defaults.headers = {
  Accept: "application/json; charset=utf-8",
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "-1",
};

axios.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = localStorage.getItem("lang");

    // Get token from sessionStorage first (current session), then localStorage (persistent)
    let token = sessionStorage.getItem("jwt_token") || localStorage.getItem("jwt_token");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;

    config.headers["ApplicationName"] = "CTS Web";

    const excludedUrls = [
      "AddUpdatePublicAnnouncement",
      "NotifyEmail",
      "NotificationsTemplates",
      "AddDispatchLetter",
    ];
    
    if (
      config.data &&
      isXSSAttempt(config.data) &&
      !excludedUrls.some((url) => config.url.includes(url))
    ) {
      alert("Malicious input detected");
      throw new Error("Custom XSS Interceptor Error: XSS Attempt");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    if (error.response && (error.response.status == 428 || error.response.status == 401)) {
      if (window.SessionGuard)
        window.SessionGuard.signOut("expired");
      else
        document.getElementById("logout").click();

      return;
    }else {

    // Save current path
    const path = window.location.pathname;
    sessionStorage.setItem("pathname", path);

    // Handle 401s globally
    if (error.response.status === 401) {
      console.warn("Unauthorized - token expired or invalid");

      // Optional: clear localStorage/sessionStorage tokens here

      // Redirect or trigger login
      //window.location.href = "/";
    }
  }
  }

  //return Promise.reject(error);
});

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.use(VueWysiwyg);
Vue.use(FloatingVue);

Vue.component("apexchart", VueApexCharts);

// #login only exists on the static login pages, so on deep routes like /inbox the old document.getElementById("login").click() threw on null and dumped us at error.html.
// login() is the global from public/assets/js/app.js - a classic script, so it has already executed by the time this deferred bundle runs.
function signIn() {
    if (typeof window.login === "function")
        window.login();
    else
        window.location.href = "/login2.html";
}

axios
  .get(
    sessionStorage.getItem("customApiPath") + "StructureUser/GetCurrentUserInfo"
  )
  .then((res) => {
    var user = JSON.parse(sessionStorage.getItem("user"));
    if (user != null  && res != null) {
      user.profile.DisplayName = res.data.displayName;
      user.profile.CompanyId = res.data.companyId
      user.profile.StructureId = res.data.structureId;
      user.profile.IsNeedResetSignaturePin = res.data.isNeedResetSignaturePin;
      user.profile.EditSigned = res.data.editSigned;
      user.profile.CanCreateWithoutFile = res.data.canCreateWithoutFile;
      if (
        res.data.headOfDepartmentUserId != null &&
        res.data.headOfDepartmentUserId != undefined
      )
        user.profile.HeadOfDepartmentUserId = res.data.headOfDepartmentUserId;
      if (
        res.data.headOfDepartmentStructureId != null &&
        res.data.headOfDepartmentStructureId != undefined
      )
        user.profile.HeadOfDepartmentStructureId =
          res.data.headOfDepartmentStructureId;

      sessionStorage.setItem("user", JSON.stringify(user));
      document.title = constants.applicationTitle;

      //YAZAN :: the condition will be True if the user has changed the preferred language in another browser, so we need to reload the page to apply the new language.
      const preferredLanguage = res.data.preferredLanguage;
      if ((preferredLanguage == "en" || preferredLanguage == "ar") &&
        preferredLanguage != localStorage.getItem("lang")) 
      {
        localStorage.setItem("lang", preferredLanguage);
        window.location.reload();
        return;
      }

      if (localStorage.getItem("lang") == null)
        localStorage.setItem("lang", defaultApplicationLanguage);

      Promise.all([
        axios.get(
          sessionStorage.getItem("customApiPath") +
            "Document/GetDocumentLookups"
        ),
        store.dispatch("fetchTransferPurposes"),
      ])
        .then(([res]) => {
          res.data.forEach((lookup) => {
            switch (lookup.key) {
              case "Privacy":
                window.privacies = lookup.value;
                constants.privacies = lookup.value;
                break;
              case "Priority":
                window.priorities = lookup.value;
                constants.priorities = lookup.value;
                break;
              case "Importance":
                window.importancies = lookup.value;
                constants.importancies = lookup.value;
                    break;
                //YAZAN :: ->
              // Purpose is fetched once centrally via fetchTransferPurposes()
              // (Lookups/get-all-purposes -> store + constants.purposes, incl. color).
              case "Categories":
                lookup.value = lookup.value.filter(
                  (category) =>
                    (category.id != constants.categoriesEnum.Decree ||
                      window.isDecreeEnabled) &&
                    (category.id != constants.categoriesEnum.Circular ||
                      window.isCircularEnabled)&&
                    (category.id != constants.categoriesEnum.Contract ||
                      window.isContarctEnabled)
                );
                window.categories = lookup.value;
                constants.categories = lookup.value;
                break;
              case "Status":
                const statusColors = {
                  1: "",
                  2: "info",
                  3: "success",
                  4: "danger",
                  5: "info",
                };
                lookup.value.forEach((status) => {
                  status.key = status.name.replace(/\s/g, "");
                  status.classColor = statusColors[status.id] || "";
                });
                //window.statuses = lookup.value;
                //constants.statuses = lookup.value;
                break;
              default:
                break;
            }
          });
          // YAZAN :: The session can disappear while the calls above are in flight: a failed silent renew calls logout(), which clears sessionStorage.user. Mounting at that point throws inside App's data() and leaves the user on a blank page.
          if (sessionStorage.getItem("user") == null) {
            signIn();
            return;
          }

          const app = new Vue({
            render: (h) => h(App),
            router,
            store,
            vuetify,
            i18n,
          }).$mount("#app");
        })
        .catch((err) => {
          console.log(err);
         // debugger
          window.location.href = "/error.html";
        });
    } else {
      signIn();
    }
  })
  .catch((err) => {
    console.log(err);
    //debugger
    window.location.href = "/error.html";
  });
